import services from "../../../libs/services";
import threeSketch from "../../../libs/three-sketch";
import * as THREE from "three";
import EmitEvent, {
    HT_RESIZE,
    OBSERVER_HEIGHT_CHANGED,
    PAGE_ENTER,
    PAGE_LOADED,
    SMOOTH_SCROLLING
} from "../../../libs/emit-event";
import {imgSrcOriginal, ThreeJsGetX, ThreeJsGetY} from "../../../libs/helper";
import f from "./f.glsl";
import v from "./v.glsl";

export class ImageItem {

    constructor({el, addGroup, uniforms}) {
        this.DOM = {el};
        this.prop = {top: 0};
        this.addGroup = addGroup;

        this.uniforms = {
            ...uniforms, ...{
                u_texture: {value: null},
                u_size: {value: new THREE.Vector2()},
                u_res: {value: new THREE.Vector2(services.winSize.width, services.winSize.height)},
                u_radius: {value: .009}
            }
        };

        this.zIndex = parseFloat(this.DOM.el.getAttribute('data-zIndex')) || 0;
        this.pageLoaded = this.pageLoaded.bind(this);
        this.handleScrolling = this.handleScrolling.bind(this);
        this.pageResize = this.pageResize.bind(this);

        this.init();
        this.bindEvent();
    }

    getProp() {
        const scrollTop = Math.abs(services.smooth_scrolling_instance);
        const {top, width, height, left} = this.DOM.el.getBoundingClientRect();
        this.prop.top = top + scrollTop;
        this.prop.live = top;
        this.prop.left = left;
        this.prop.width = width;
        this.prop.height = height;
        this.uniforms.u_size.value = {
            x: this.prop.width,
            y: this.prop.height
        };

    }

    init() {
        const image = this.DOM.el.querySelector('img');
        const src = imgSrcOriginal (image);
        threeSketch.loadTexture({src}).then(this.initTexture.bind(this));
    }

    initTexture(texture) {
        this.getProp();

        this.uniforms.u_texture.value = texture;
        // this.uniforms.u_texture.value.magFilter = THREE.NearestFilter;
        this.uniforms.u_texture.value.minFilter = THREE.LinearFilter;

        const geo = new THREE.PlaneBufferGeometry(1, 1, 20, 20);
        const mat = new THREE.ShaderMaterial({
            uniforms: this.uniforms,
            fragmentShader: f,
            vertexShader: v,
            transparent: true,
        });
        this.mesh = new THREE.Mesh(geo, mat);
        this.addGroup(this.mesh);

        this.DOM.el.style.visibility = 'hidden';
        this.setSize();
    }

    setSize() {
        if (this.mesh) {
            this.mesh.scale.set(this.prop.width, this.prop.height, 1);
            this.mesh.position.set(ThreeJsGetX(this.prop.left, this.prop.width), ThreeJsGetY(this.prop.live, this.prop.height), this.zIndex * .1);
        }
    }

    pageLoaded() {
        this.getProp();
        this.setSize();
    }

    handleScrolling(instance) {
        if (this.mesh) {
            const disTop = (this.prop.top + instance);
            this.mesh.position.y = ThreeJsGetY(disTop, this.prop.height);
        }
    }

    pageResize() {
        this.uniforms.u_res.value = new THREE.Vector2(services.winSize.width, services.winSize.height);
        this.getProp();
        this.setSize();

    }

    bindEvent() {
        EmitEvent.on(HT_RESIZE, this.pageResize);
        EmitEvent.on(OBSERVER_HEIGHT_CHANGED, () => {
            this.pageResize();
        });
        EmitEvent.on(PAGE_LOADED, this.pageLoaded);
    }

    removeEvent() {
        EmitEvent.off(HT_RESIZE, this.pageResize);
        EmitEvent.off(OBSERVER_HEIGHT_CHANGED, this.pageResize);
        EmitEvent.off(PAGE_LOADED, this.pageLoaded);
    }
}